export const snakeToCamel = (str: string): string => {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace('-', '').replace('_', ''),
  );
};

export const camelToSnake = (str: string): string => {
  return str.replace(/[A-Z]/g, (group) => `_${group.toLowerCase()}`);
};
